import ApiClient from '../ApiClient';

// Resumo financeiro de um cliente, para a barra lateral da conversa.
// Só admin — a regra é imposta no servidor (Financial::BaseController).
class ContactSummariesAPI extends ApiClient {
  constructor() {
    super('financeiro/contact-summaries', { accountScoped: true });
  }
}

export default new ContactSummariesAPI();
